import _ from 'lodash';

function HOClaimExtension(claim) {
    if (claim && claim.lobs && claim.lobs.homeowners) {
        _.extend(this, claim.lobs.homeowners);
    }
}

export default HOClaimExtension;
